'use strict'

import { tns } from "tiny-slider/src/tiny-slider";

const slider =  {
    init: function(){
        slider.arrows();
        slider.tabs();
        slider.tabsWidth();
    },

    // slider à flèches (centres-slider.php sur le site .com)
    arrows: function () {
        let element = document.querySelector('.arrowSlider_wrap');
        if (element) {
            let itemMobile = element.dataset.mobile,
                itemTablet = element.dataset.tablet,
                itemDesktop = element.dataset.desktop;
            let slider = tns({
                container: '.arrowSlider_wrap',
                mode: "carousel",
                items: itemMobile,
                autoplay: false,
                gutter: 0,
                mouseDrag: true,
                controls: true,
                nav: false,
                autoplayText: false,
                autoplayButton: false,
                speed: 1000,
                loop: false,
                responsive: {
                    768: {
                      items: itemTablet,
                      gutter: 20
                    },
                    1024: {
                        items: itemDesktop,
                        gutter: 40
                    }
                }
            });
            let parent = document.querySelector('.arrowSlider'),
                counter = document.createElement('div'),
                info = slider.getInfo(),
                total = info.slideCountNew;
            
            counter.classList.add('arrowSlider_paging');
            counter.innerHTML = '1 / ' + total;
            parent.appendChild(counter);
            
            slider.events.on('indexChanged', function() {
                let info = slider.getInfo(),
                    total = info.slideCountNew,
                    i = info.index + 1;
                counter.innerHTML = i + ' / ' + total;
            });
        }
    },
    
    // slider sur les page modules à onglets
    tabs: function() {

        let tabsList = document.querySelector('.tabs_list');
        let articles = document.querySelector('.tabs_containers');

        if(articles && tabsList) {
            
            let articlesSlider = tns({
                container: articles,
                mode: "carousel",
                items: 1,
                autoplay: false,
                mouseDrag: true,
                navContainer: tabsList,
                controls: false,
                nav: true,
                speed: 1000,
                loop: false,
                autoHeight: true,
                responsive: {
                    1025: {
                        mouseDrag: false,
                    },
                }
            });
            
            const slider = tabsList.parentElement;
            slider.scrollLeft = 0;
            let isDown = false;
            let startX;
            let scrollLeft;

            articlesSlider.events.on('indexChanged', function() {
                let info = articlesSlider.getInfo();
                let index = info.index;
                let last = info.indexCached;
                let margin = 0;
                window.matchMedia("(max-width: 1023px)").matches ? margin = 0 : margin = 65;

                if(index === 0) {
                    slider.scrollLeft = 0;
                } else if(index > last) {
                    // next
                    let left = slider.querySelector('.tabs_btn[data-tab="' + index + '"]').offsetLeft;
                    let width = slider.querySelector('.tabs_btn[data-tab="' + index + '"]').offsetWidth;
                    slider.scrollLeft = left + width - margin;
                } else {
                    // prev
                    let left = slider.querySelector('.tabs_btn[data-tab="' + index + '"]').offsetLeft;
                    let width = slider.querySelector('.tabs_btn[data-tab="' + index + '"]').offsetWidth;
                    slider.scrollLeft = left + width - margin;
                }
            });
        
            slider.addEventListener('mousedown', (e) => {
                isDown = true;
                startX = e.pageX - slider.offsetLeft;
                scrollLeft = slider.scrollLeft;
            });
            slider.addEventListener('mouseleave', () => {
                isDown = false;
            });
            slider.addEventListener('mouseup', () => {
                isDown = false;
            });
            slider.addEventListener('mousemove', (e) => {
                if(!isDown) return;
                e.preventDefault();
                const x = e.pageX - slider.offsetLeft;
                const walk = (x - startX) * 3; // scroll-fast
                slider.scrollLeft = scrollLeft - walk;
            });
        }
    },

    // mise en place (si besoin) d'une scrollbar sur la liste des onglets
    tabsWidth: function() {
        let tabsList = document.querySelector('.tabs_list');

        if(tabsList) {
            let tabsBtn = tabsList.querySelectorAll('.tabs_btn');
            let tabsWidth = 40;
            tabsBtn.forEach(btn => {
                tabsWidth = tabsWidth + btn.offsetWidth + 20;
            });
    
            tabsList.style.width = tabsWidth + 'px';
        }
    },
}


export default slider;



// WEBPACK FOOTER //
// ./src/scripts/components/slider.js